





























import { Component, Vue, Prop } from 'vue-property-decorator'

import RoundAvatar from '@/components/RoundAvatar.vue'
import StatusLabel from '@/components/StatusLabel.vue'

import Booking from '@/models/booking'
import BookingStatus from '@/models/booking-status'
import Customer from '@/models/customer'

import dayjs from '@/dayjs'

@Component({
  components: {
    StatusLabel,
    RoundAvatar,
  },
})
export default class BookingCard extends Vue {
  @Prop() booking!: Booking
  @Prop() inviter!: Customer

  get statusInfo(): string {
    if (this.booking.status === BookingStatus.EXPIRED) {
      return `Expired ${dayjs(this.booking.expire).fromNow()}`
    } else {
      const departure = dayjs.utc(this.booking.departAt)

      if (departure.isSame(dayjs.utc(), 'day')) {
        return 'Departing Today'
      } else if (departure.isSame(dayjs.utc().add(1, 'day'), 'day')) {
        return 'Departing Tomorrow'
      } else if (departure.isSame(dayjs.utc().subtract(1, 'day'), 'day')) {
        return 'Departed Yesterday'
      }

      const prefix = departure.isAfter() ? 'Departing' : 'Departed'
      return `${prefix} ${dayjs(this.booking.departAt).fromNow()}!`
    }
  }

  get bookingLabel(): string {
    if (this.isBookingCancelled) {
      return 'cancelled'
    } else if (this.booking.status === BookingStatus.CONFIRMED) {
      return 'confirmed'
    }

    return ''
  }

  get background(): { backgroundImage: string } | null {
    if (!this.booking.productDashboardBackgroundImageUrl) {
      return null
    }
    return {
      backgroundImage:
        'url(' + this.booking.productDashboardBackgroundImageUrl + ')',
    }
  }

  get isBookingCancelled() {
    return this.booking.status === BookingStatus.CANCELLED
  }
}
